module.exports = __webpack_public_path__ + "media/unipod/icon-speed-7b8fe417.svg";